import { createFileRoute } from "@tanstack/react-router";
import { PlatformSchedulerPage } from "@/components/platform-scheduler-page";
import { buildPageHead } from "@/lib/seo-meta";

const path = "/channels/pinterest";

export const Route = createFileRoute(path)({
	component: PinterestScheduler,
	head: ({ matches }) =>
		buildPageHead({
			matches,
			internalPath: path,
			title: "AgentReacher | Connect your AI agent to Pinterest",
			description:
				"Schedule Pinterest pins to boards with an AI agent. Drafts titles, descriptions, and timing. Cancel anytime.",
		}),
});

function PinterestScheduler() {
	return (
		<PlatformSchedulerPage
			platform="pinterest"
			platformLabel="Pinterest"
			hero={{
				title: "Connect your AI agent to Pinterest",
				description:
					"Schedule pins to the right board, with titles and descriptions drafted by an agent that learned your voice.",
			}}
		/>
	);
}
